import React, {useState, useEffect} from 'react';
import { withRouter } from 'react-router-dom';
import ActionFormLayout from '../../../../../components/layouts/actions/ActionFormLayouts';
import {List} from 'antd-mobile';
import TeamChoice from '../../../../../components/customForm/teamchoice/TeamChoice';
import Title from '../../../../../components/Title';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchLive, addActionLive, editActionLive } from '../../../../../actions/liveDataActions';
import { getChronoFromLiveDebut } from '../../../../../helpers';
import _ from 'lodash';
import PickerInput from '../../../../../components/customForm/picker/PickerInput';
import NumberInput from '../../../../../components/customForm/number/NumberInput';
import { addAction } from '../../../../../services/live';
import { editAction } from '../../../../../services/action';
import { LOGO_TEAM_URL } from '../../../../../config.env';

const Cartons = props => {
    const access = props.connexionReducer;
    const {id} = props.match.params;
    const [formValid, setFormValid] = useState(false);
    const qs = queryString.parse(props.history.location.search);
    const dataEdited = qs.action_edit ? JSON.parse(qs.action_edit) : null;
    const [team, setTeam] = useState(dataEdited ? dataEdited.teamId : '');
    const [teamName, setTeamName] = useState(dataEdited ? dataEdited.data.teamName : '');
    const [type, setType] = useState(dataEdited ? dataEdited.data.inputs.value : '');
    const min = qs.actions ? parseInt(getChronoFromLiveDebut(JSON.parse(qs.actions))) : 0;
    const [minute, setMinute] = useState(dataEdited ? dataEdited.minute || 0 : min);
    const editId = dataEdited ? dataEdited['@id'] : '';
    const match = props.liveDataReducer[`/api/lives/${id}`] ? props.liveDataReducer[`/api/lives/${id}`].match : {};
    const actionId = qs.action_type ? JSON.parse(qs.action_type)['@id'] : '';
    const score = qs.score ? JSON.parse(qs.score) : {home: null, away: null}
    const [showBtnSubmit, setShowBtnSubmit] = useState(true);
    const [isOnSubmit, setIsOnSubmit] = useState(false);
    let dataType = dataEdited ? dataEdited.data.inputs.array : []

    try {
        const actionType = _.find(JSON.parse(qs.action_type).data.inputs, {title: 'Détails du carton'}).values
        dataType = _.toArray(_.mapValues(actionType, (val, key) => ({value: _.toLower(_.values(val)), label:_.values(val)[0] })));
    }
    catch(e) {}

    useEffect(() => {
        if(access) {
            props.fetchLive(id, access);
        }
        setFormValid(team !== '' && type !== '' && minute !== '' && minute !== null);
    }, [team, type, minute, access])

    return (
        <ActionFormLayout
            title='cartons'
            enabled={formValid}
            submit={() => submit(id, actionId, {team, teamName, type, minute, score, inputs: dataType}, access, props, editId, setFormValid, setIsOnSubmit)}
            showBtn={showBtnSubmit}
            isOnSubmit={isOnSubmit}
        >
            <div className='ls_debut_form'>
                <List>
                    <TeamChoice 
                        header={() => <Title text='équipe qui a reçu le carton' />}
                        teams={[
                            {icon: `${LOGO_TEAM_URL}/${match.homeTeamClCod}.jpg`, text: match.homeTeam, teamId: match.homeTeamClCod, name: match.homeTeamEqName},
                            {icon: `${LOGO_TEAM_URL}/${match.awayTeamClCod}.jpg`, text: match.awayTeam, teamId: match.awayTeamClCod, name: match.awayTeamEqName}
                        ]}
                        teamName={team}
                        onChange={(id, name) => {setTeam(id); setTeamName(name)}} 
                    />
                    <List renderHeader={() => <Title text='détails du carton' />}>
                        <PickerInput data={dataType} label='Type de carton' extra='à renseigner' value={type} onOk={setType} />
                        <NumberInput 
                            label='Minute' 
                            min={0}
                            value={minute}
                            defaultValue={minute} 
                            onChange={setMinute} 
                            id='ls_minute_cartons' 
                            onFocus={() => setShowBtnSubmit(false)} 
                            onBlur={() => setShowBtnSubmit(true)} />
                    </List>
                </List>
            </div>
        </ActionFormLayout>
    )
}

const submit = (id,actionId,data, access, props, editId, setFormValid, setIsOnSubmit) => {
    setFormValid(false);
    setIsOnSubmit(true);
    const color = data.type === 'carton jaune' ? 'yellow' : (data.type === 'carton rouge' ? 'red' : 'white');
    const dataAction = {
        label: _.join(_.split(data.type, ' '), '-'),
        actionName: `${_.capitalize(data.type)} pour ${data.teamName}`,
        team: data.team,
        teamName: data.teamName,
        color,
        inputs: {
            value: data.type,
            array: data.inputs
        }
    }
    if(editId !== '') {
        editAction(editId, {
            teamId: parseInt(data.team),
            teamName: data.teamName,
            minute: parseInt(data.minute),
            score: data.score,
            color,
            data: dataAction
        }, access, id, actionId).then(response => {
            setIsOnSubmit(false);
            props.editActionLive(id, response.data);
            props.history.push(`/live/${id}`);
        })
    }
    else {
        addAction(id, {
            type: actionId,
            teamId: parseInt(data.team),
            teamName: data.teamName,
            minute: parseInt(data.minute),
            score: data.score,
            color,
            data: dataAction
        }, access).then(response => {
            window.postMessage(JSON.stringify({
                action: 'trackEvent',
                parameters: {
                    label: 'added_live_score',
                    value: 'déclarer un carton'
                }
            }), '*');
            setIsOnSubmit(false);
            props.addActionLive(id, response.data);
            props.history.push(`/live/${id}`);
        })
    }
}

const mapStateToProps = ({liveDataReducer, connexionReducer}) => ({liveDataReducer, connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({fetchLive, addActionLive, editActionLive}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Cartons));